import projectQueries from '@apis/queries/projectQueries';
import { useQuery } from '@tanstack/react-query';

function useProject() {
    const { data } = useQuery(projectQueries.detail());
    return data;
}

export default useProject;
